import React from 'react';
import PropTypes from 'prop-types';
import {NavLink} from 'react-router-dom';

import {Flex, Heading, Link, Text} from '@spothero/ui';

const subMenuGroupHeadingStyleProps = {
    fontSize: 'sm',
    color: 'text.secondary.light',
    paddingX: 3.5,
    paddingBottom: 3,
};

const subMenuGroupItemStyleProps = (isDisabled) => ({
    fontSize: 'sm',
    color: 'black',
    paddingY: 3,
    paddingX: 3.5,
    // react-router-dom does not support the isDisabled prop, so we instead use the following conditional to disable the link
    ...(isDisabled && {
        color: 'gray.medium',
        cursor: 'not-allowed',
        pointerEvents: 'none',
    }),
});

const SubMenuGroup = ({heading, submenu, onClick}) => {
    return (
        <Flex direction="column">
            <Heading as="h3" {...subMenuGroupHeadingStyleProps}>
                {heading}
            </Heading>
            {submenu.map(
                (
                    {
                        label: submenuLabel,
                        subtitle,
                        route: submenuRoute,
                        isDisabled,
                    },
                    submenuIndex
                ) => {
                    return (
                        <Link
                            key={submenuIndex}
                            as={NavLink}
                            to={submenuRoute}
                            onClick={onClick}
                            {...subMenuGroupItemStyleProps(isDisabled)}
                        >
                            <Text fontSize="sm">{submenuLabel}</Text>
                            <Text fontSize="xs" fontWeight="light">
                                {subtitle}
                            </Text>
                        </Link>
                    );
                }
            )}
        </Flex>
    );
};

SubMenuGroup.propTypes = {
    heading: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    submenu: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            subtitle: PropTypes.string,
            route: PropTypes.string.isRequired,
            isDisabled: PropTypes.bool,
        })
    ).isRequired,
};

export default SubMenuGroup;
